/**
 * Get today's date as YYYY-MM-DD in the browser's local timezone.
 * Uses 'en-CA' locale which outputs ISO format (YYYY-MM-DD).
 */
export function getLocalToday(): string {
  return new Date().toLocaleDateString('en-CA');
}
